<template>
    <section id="app-payment-report" class="content-wrapper">

        <app-page-top-section :title="$t('payment_report')" icon="briefcase">
            <app-default-button
                @click="exportPaymentSummary"
                :title="$fieldTitle('export', '', true)"/>
        </app-page-top-section>

        <div class="mb-3" v-html="filterHtml"></div>

        <app-table :id="table_id" :options="options" v-if="options.url" @action=""></app-table>

    </section>
</template>

<script>
import DatatableHelperMixin from "../../../../../common/Mixin/Global/DatatableHelperMixin";
import PaymentReportMixins from "./PaymentReportMixins";
import {PAYMENT_REPORT_EXPORT} from "../../../../Config/ApiUrl-CP";
import {numberWithCurrencySymbol} from "../../../../Helper/Helper";
import {mapGetters} from "vuex";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: 'PaymentReport',
    mixins: [DatatableHelperMixin, PaymentReportMixins],
    data() {
        return {
            table_id: 'payment-report-table',
            numberWithCurrencySymbol,
            exportLoading: false,
            branch_or_warehouse_id: this.getBranchOrWarehouseId,
        };
    },
    methods: {
        exportPaymentSummary() {
            window.open(urlGenerator(`${PAYMENT_REPORT_EXPORT}/?branch_or_warehouse_id=${this.getBranchOrWarehouseId}`,'_blank'));
        },
    },
    computed: {
        ...mapGetters(['getBranchOrWarehouseId']),
    },
    watch: {
        getBranchOrWarehouseId(new_id) {
            this.branch_or_warehouse_id = new_id
        },
    }
};
</script>
